import { MotorPromoReqMdl, MotorPromoResMdl } from './MotorPromoReqMdl';
import { MotorStatusMdl } from './MotorStatusMdl';
import { MotorAddressMdl } from './MotorAddressMdl';
import { MotorDriverMdl } from './MotorDriverMdl';
import { MotorVehMdl } from './MotorVehMdl';
import { DriverHistoryDetails } from './DriverHistoryDetails';
import { CompCover } from './CompCover';
import { TPLCover } from './TPLCover';
import { PreClaimHistoryDetails } from './PreClaimHistoryDetails';
import { ProposalTrackingReq } from '../Models/ProposalTrackingReq';
import { TPL_COVERS_NEW } from './TPL_COVERS_NEW';
import { COMP_COVERS_NEW } from './COMP_COVERS_NEW';
export class MotorProposal {

    public isEditProposal: boolean;
    public EditedProposalNo: string;
    public ProposalEffFrom: Date;
    public ProposalEffTo: Date;;
    public SumInsured: number;
    public ProductCode: string;
    public SchemeCode: string;
    public Insured_IDNo: string;
    public SequenceNo: string;
    public CustomId: string;
    public CustomIssuanceDate: string;
    public VDT: string;
    public OwnerID: string;
    public isTransferOfOwnership: boolean;
    public Insured_Name: string;
    public Insured_DOB_DS: string;
    public Insured_DOB: string;
    public Insured_DOB_HIJRI: string;
    public InsuredDOB: string;
    public Insured_MobileNo: string;
    public Insured_PhoneNo: string;
    public Insured_EmailId: string;
    public MetAccident: boolean;
    public Gender: string;
    public Userid: string;
    public Under21: boolean;
    public LangFlag: string;
    public AgencyRepair: string;
    public AgencyRepairExists: boolean;
    public MetAccidentRemarks: string;
    public DeductableCode: string;
    public CountryofOrigin: string;
    public DriverAccidents: string;
    public InsuredAccidents: string;
    public TotalNoofAccedents: string;
    public TotalLiability: string;

    public Driver_UnderWriter: string;
    public VehicleLogId: string;
    public TotalNoofAccidentsVH: string;
    public ChangeInOwnership: string;
    public OwnerInsIDNo: string;
    public InsuredName_Eng: string;
    public InsuredName_Ar: string;
    public AccidentLoadingFlag: string;
    public DependentDetails: string;
    public Profession: string;
    public Ins_MaritalStatus: string;
    public Ins_MaritalStatusExists: boolean;
    public Ins_HealthStatus: string;
    public Noofyearclaimfree: string;
    public ProfessionDesc: string;
    public ClaimedAmount: string;
    public LossRatio: string;
    public PrevInsuranceCompany: string;
    public ExLoadingPercent: string;
    public ExLoadingAmount: string;
    public ExLoading_UW: string;
    public Ins_dependents: string;
    public HealthDescription: string;
    public Comercial_UW: string;
    public Ins_Age: string;
    public TraficOffences: string;
    public ApprovedClaimFreeYears: string;
    public Veh_Purchase: boolean;
    public Driver_mediacalCondition: boolean;
    public Dr_PhyDisability: boolean;
    public Dr_LicenseSuspended: boolean;
    public MotoringOffence: boolean;
    public CriminalOffence: boolean;
    public NajmNCDService_UW: string;
    public NajmNcdReqRefNo: string;
    public Ins_OfficePhoneNo: string;
    public Ins_WStreetName: string;
    public Ins_WDistrictName: string;
    public PreviousDriversDetails: string;
    public PrvAccidents: string;
    public idExpiryDate: string;
    public idExpiryDateHijri: string;
    public Bankname: string;
    public IBANNumber: string;
    public IDRegistrationCity: string;
    public IDRegistrationRegionCode: string;
    public IDCity: string;
    public IDRegionName: string;

    public CALCULATED_REGION_CODE: string;
    public TPL_SchemeCode: string;
    public COMP_SchemeCode: string;
    public tplCovers: Array<TPL_COVERS_NEW> = new Array<TPL_COVERS_NEW>();
    public compCovers: Array<COMP_COVERS_NEW> = new Array<COMP_COVERS_NEW>();
    public driverHisObj: DriverHistoryDetails = new DriverHistoryDetails();
    public preClaimObj: PreClaimHistoryDetails = new PreClaimHistoryDetails();
    public vehcileObj: MotorVehMdl = new MotorVehMdl();
    public driverListObj: Array<MotorDriverMdl> = new Array<MotorDriverMdl>();
    public addressObj: MotorAddressMdl = new MotorAddressMdl()
    public driverNcdObj: Array<MotorDriverDetailMdl> = new Array<MotorDriverDetailMdl>();
    public driverNCDDetialObj: Array<NCDDetails> = new Array<NCDDetails>();
    public PromoReq: MotorPromoReqMdl = new MotorPromoReqMdl();
    public TPLPromoRes: MotorPromoResMdl = new MotorPromoResMdl();
    public COMPPromoRes: MotorPromoResMdl = new MotorPromoResMdl();
    public PromoRes: MotorPromoStatusMdl = new MotorPromoStatusMdl();

    public RegNo: string;
    public isEportal: boolean;
    public MinSumInsured: number;
    public MaxSumInsured: number;
    public st: MotorStatusMdl = new MotorStatusMdl();


    public NajmNCDFlag: boolean;

    public HasComprehensive: boolean;
    public HasTPL: boolean;
    public LicenceExpiryDate: string;
    public LicenceExpiryDateH: string;
    public LicenceExpiryDateExists: boolean;

    public isDriverRequired: boolean;
    public isDriverMandatory: boolean;

    public IsItCommercial: boolean;
    public vechilekept: boolean;

    public YakeenLogid: string;
    public YakeenLogidInsured: string;
    public YakeenLogidSP: string;

    //TPL
    public GrossPremium: number;

    public NCDPercentage: number;
    public NCDAmount: number;

    public LDPercentage: number;
    public LDAmount: number;

    public CrossSellDisPercent: number;
    public CrossSellDiscount: number;

    public PromoPercent: number;
    public PromoDiscount: number;

    public TotalPremiumBeforeVAT: number;

    public VAT_PERCENT: number;
    public VAT_AMOUNT: number;

    public UserDiscountPer: number;
    public UserDiscountAmt: number;
    public Driver_DISC_AMOUNT: number | null;
    public COMP_Driver_DISC_AMOUNT: number | null;
    public UPR_VAT_AMOUNT: number | null;
    public COMP_UPR_VAT_AMOUNT: number | null;
    public TotalPremium: number;
    //COMP
    public CompGrossPremium: number;

    public CompNCDPercentage: number | null;
    public CompNCDAmount: number | null;

    public CompLDPercentage: number | null;
    public CompLDAmount: number | null;

    public CompCrossSellDisPercent: number;
    public CompCrossSellDiscount: number;

    public CompPromoPercent: number;
    public CompPromoDiscount: number;

    public CompTotalPremiumBeforeVAT: number;

    public CompVAT_PERCENT: number | null;
    public CompVAT_AMOUNT: number;

    public CompUserDiscountPer: number;
    public CompUserDiscountAmt: number;

    public CompTotalPremium: number;

    public PromoID: number;
    public PromoCode: string;
    public isPromoApply: boolean;

    public isTPLSelected: boolean;
    public isCompSelected: boolean;
    public SelectedProductCode: string;

    public trackingObj: ProposalTrackingReq = new ProposalTrackingReq();

    public VechileUsageCodeExits: boolean;
    public VechileColorExists: boolean;

    public IBAN1: string;
    public IBAN2: string;
    public IBAN3: string;
    public IBAN4: string;
    public IBAN5: string;
    public IBAN6: string;

    public isInsuredMainDriver: boolean;

    public insuredDriverObj: MotorDriverMdl = new MotorDriverMdl();
    public productType: string = "0000";
    public VehicleAccidents: string;
    public InsuredEducation: string;
    public InsuredProfessin: string;
    public ChildrenUnder: string;
    public uploadsRequired: boolean;
    public ModelExisted: boolean;
    public VehicleRegExpiryExists: boolean;

    public frontImage: string;
    public backImage: string;
    public leftImage: string;
    public rightImage: string;
    public chasisImage: string;
    public InsuredIdImage: string;
    public IstharamaImage: string;
    public IsthimaraImage: string;
    public CustomIdImage: string;

    public frontImageExists: boolean;
    public backImageExists: boolean;
    public leftImageExists: boolean;
    public rightImageExists: boolean;
    public chasisImageExists: boolean;
    public InsuredIdImageExists: boolean;
    public IstharamaImageExists: boolean;

    public isTPLActive: boolean;
    public isCOMPActive: boolean;

    public DriverMaxLimit: number;
    public attachmentId: number;

    public ProposalFormFileName: string;
    public IqamaCopyFileName: string;
    public VehicleRegFileName: string;
    public DrivingLicFileName: string;
    public OtherFileName: string;

    public TPLSchemeCode: string;
    public CompSchemeCode: string;

    public NCD_CAL_CODE_TPL: number;
    public NCD_CAL_CODE_COMP: number;
    public IsHigherPosition: boolean = false;
    public HigherPositionCode: number = 0;
    public MaxEffectiveDateGracePeriod: Number;
    public ReferredBy: string;
    public AmericanID: string;
    public Proposal_Remarks: string;
    public Proposal_Status: string;
    public PreferCommLang: string;
    public PreferCommChannel: string;
    public DownLoadProposal_Tpl: string;
    public DownLoadProposal_Comp: string;
    public IsRenewal: boolean;
    public PrvPolicyNo: string;
    public IsKiosk: boolean;
    public DriverDiscPer:number;
    public DriverDiscAmount:number;
    public CompDriverDiscPer:number;
    public CompDriverDiscAmount:number;
    public VehicleDesc: string;

    public PricingToolInfo: mdlPricingToolInfo = new mdlPricingToolInfo();

    public engine_size: string;
    public transmission: string;
    public hp: string;
    
    public SurplusEstAmount: number;
    public SurplusAmount: number;
    public SurplusInquiryId: string;

    public AccountName:string;
}

export class mdlPricingToolInfo {
    public PricingToolURL_TPL: string;
    public PricingToolURL_COMP: string;
    public TPL_CalculationType: string;
    public TPL_PolicyType: string;
    public COMP_CalculationType: string;
    public COMP_PolicyType: string; 
    public PricingToolRefId_TPL: number | null; 
    public PricingToolRefId_TPL_COMP: number | null; 
    public PricingToolRefId_COMP: number | null;  
    public GGI_RiskPrice_TPL: number | null; 
    public GGI_TechPrice_TPL: number | null; 
    public MM_RiskPrice_TPL: number | null; 
    public MM_TechPrice_TPL: number | null; 
    public GGI_RiskPrice_COMP: number | null; 
    public GGI_TechPrice_COMP: number | null; 
    public MM_RiskPrice_COMP: number | null; 
    public MM_TechPrice_COMP: number | null;    
}

export class MotorDriverDetailMdl {
    public DriverType: string;
    public DriverId: string;
    public DriverGender: string;
    public DriverDOB: Date | string;
    public NCD_ClaimFreeYears: number;
    public NCD_RefNo: string;
    public st: MotorStatusMdl = new MotorStatusMdl();
}

export class NCDDetails {
    public DriverType: string;
    public DriverId: string;
    public DriverGender: string;
    public DriverDOB: Date | string;
    public NCD_ClaimFreeYears: number;
    public NCD_RefNo: string;
}
export class MotorPromoStatusMdl {
    public StatusCode: string;
    public StatusDesc: string;
    public StatusDescAr: string;
    public Result: string;
    public msgKey: string;

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/MotorProposal.ts